import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Beef, Loader2, CheckCircle } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Senhas não conferem");
    if (pw.length < 6) return toast.error("Mínimo 6 caracteres");
    if (!token) return toast.error("Link inválido");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grain flex items-center justify-center px-4 relative z-10">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-10 h-10 rounded-xl bg-red-600 flex items-center justify-center"><Beef className="w-5 h-5 text-white" /></div>
          <span className="font-display font-extrabold text-xl">CarnesWork</span>
        </Link>
        <div className="cw-card p-8 anim-fade-up">
          {done ? (
            <>
              <CheckCircle className="w-12 h-12 text-emerald-400 mb-3" />
              <h1 className="text-2xl font-display font-bold mb-2">Senha atualizada!</h1>
              <p className="text-sm text-zinc-400 mb-6">Você já pode entrar com sua nova senha. Redirecionando…</p>
              <Link to="/login" className="cw-btn-primary w-full inline-block text-center">Ir ao login</Link>
            </>
          ) : (
            <>
              <h1 className="text-2xl font-display font-bold mb-1">Nova senha</h1>
              <p className="text-sm text-zinc-400 mb-6">Defina uma senha forte para sua conta.</p>
              <form onSubmit={submit} className="space-y-3">
                <div>
                  <label className="text-xs uppercase tracking-wider text-zinc-500">Nova senha</label>
                  <input required type="password" className="cw-input mt-1" data-testid="input-new-password"
                         value={pw} onChange={e => setPw(e.target.value)} placeholder="Min. 6 caracteres" />
                </div>
                <div>
                  <label className="text-xs uppercase tracking-wider text-zinc-500">Confirmar senha</label>
                  <input required type="password" className="cw-input mt-1" data-testid="input-confirm-password"
                         value={pw2} onChange={e => setPw2(e.target.value)} placeholder="Digite novamente" />
                </div>
                <button type="submit" disabled={loading} className="cw-btn-primary w-full flex items-center justify-center gap-2" data-testid="btn-reset-submit">
                  {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Salvando…</> : "Atualizar senha"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
